module.exports = "/_next/static/images/c77caf0b0630538b15878fb163b7285d-security-lg.jpg.webp";